import { CatalogueDeploymentRow } from "routes/createContent/components/CatalogueDeploymentRow";
import { useTranslation } from "react-i18next";
import useGetExercise from "../../api/useGetExercise";
import ExercisePreview from "../../components/ExercisePreview";
import { useParams, Link } from "react-router-dom";
import { Button, Box } from "@material-ui/core";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { CataloguePath } from "routes/createContent/paths";
import { useGetDeployableCatalogueEntry } from "../../api/catalogueDeployments";
import { CatalogueGaps } from "../../components/CatalogueGaps";

export const ViewExercise: React.VFC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const exerciseId = parseInt(id, 10);
  const { data: exercise, isLoading, error } = useGetExercise(exerciseId);
  const exerciseName = exercise?.name;
  const { data: deployable } = useGetDeployableCatalogueEntry("exercise", exerciseName ?? "", Boolean(exerciseName));

  return (
    <div>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button
          component={Link}
          to={`${CataloguePath.Exercises}/${exerciseId - 1}`}
          disabled={exerciseId <= 1}
          startIcon={<ArrowBack />}
        >
          {t("view_exercise.previous")}
        </Button>
        <Box>{t("view_exercise.id_label", { exerciseId })}</Box>
        <Button component={Link} to={`${CataloguePath.Exercises}/${exerciseId + 1}`} endIcon={<ArrowForward />}>
          {t("view_exercise.next")}
        </Button>
      </Box>
      {exerciseName && (
        <Box mb={2}>
          <CatalogueDeploymentRow
            kind="exercise"
            name={exerciseName}
            rollout={exercise?.rollout}
            gaps={deployable?.gaps}
          />
          <CatalogueGaps gaps={deployable?.gaps} />
        </Box>
      )}
      {isLoading && <div>{t("view_exercise.loading")}</div>}
      {error && <div>{t("view_exercise.error_loading")}</div>}
      {exercise && <ExercisePreview exercise={exercise} />}
    </div>
  );
};
